import { portalRoles } from '../enums/portalRoles';
import moment from 'moment-timezone';
import { contactsProfileTypeFilters } from '../enums/contactsProfileTypeFilters';
import Vue from 'vue';

class ProfileUtil {
  getCanUseSecureLoginServices({ profile }) {
    if (profile.role !== portalRoles.CHILD || profile.birthday == null) {
      return true;
    }

    return moment().diff(moment(profile.birthday), 'years') >= 15;
  }

  getChildProfileTypes() {
    return [contactsProfileTypeFilters.CHILD, contactsProfileTypeFilters.BOY, contactsProfileTypeFilters.GIRL];
  }

  /**
   * Generates a formatted address string from an address object
   * @param {Object} addressObj - The address object containing street, postalCode, and postalDistrict
   * @returns {string} The formatted address string
   */
  generateAddress(addressObj) {
    let address;
    if (addressObj == null) {
      address = Vue.prototype.$getText('USERS_LABEL_ADDRESS') + ' ' + Vue.prototype.$getText('UNKNOW').toLowerCase();
    } else if (addressObj.street === Vue.prototype.$getText('UNKNOW')) {
      address = Vue.prototype.$getText('USERS_LABEL_ADDRESS') + ' ' + Vue.prototype.$getText('UNKNOW').toLowerCase();
    } else {
      address =
        addressObj.street +
        ', ' +
        (addressObj.postalCode != null ? addressObj.postalCode : Vue.prototype.$getText('UNKNOW')) +
        ' ' +
        (addressObj.postalDistrict != null ? addressObj.postalDistrict : Vue.prototype.$getText('UNKNOW'));
    }
    return address;
  }

  /**
   * Generates initials from a profile's name
   * @param {Object} institutionProfile - The profile object containing name information
   * @returns {string} The initials of the profile's name
   */
  displayProfileInitials(institutionProfile) {
    if (institutionProfile.shortName != null) {
      return institutionProfile.shortName;
    }

    const displayName = this.displayProfileName(institutionProfile);
    const startIndex = 0;
    const endIndex = 2;
    return displayName
      .split(' ')
      .map(name => name[0])
      .filter(Boolean)
      .slice(startIndex, endIndex)
      .join('')
      .toUpperCase();
  }

  /**
   * Display profile name
   * @param {Object} institutionProfile - The profile object containing name information
   * @returns {string} The name of the profile
   */
  displayProfileName(institutionProfile) {
    const names = [];
    if (institutionProfile.fullName != null) {
      names.push(institutionProfile.fullName);
    } else if (institutionProfile.name != null) {
      names.push(institutionProfile.name);
    } else {
      names.push(institutionProfile.firstName, institutionProfile.lastName);
    }
    return names.join(' ');
  }
}

export const profileUtil = new ProfileUtil();
